import React from 'react'

const  DeliveryOrderDetails= () => {
  return (
    <div> DeliveryOrderDetails</div>
  )
}

export default DeliveryOrderDetails;